module.exports = __webpack_public_path__ + "static/media/loadingblue.d1499ca4.svg";